import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ActionSheetController, ToastController, Platform, LoadingController, Loading } from 'ionic-angular';

import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
//import { Http, Headers, RequestOptions } from '@angular/common/http';



import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { GlobalProvider } from "../../providers/global/global";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Storage } from '@ionic/storage';

import { LoginPage } from '../login/login';
import { VisitorsPreRegPage } from '../visitors-prereg/visitors-prereg';
import { ViewvisitorPage } from '../viewvisitor/viewvisitor';
import { VisitorreportPage } from '../visitorreport/visitorreport';



/**
 * Generated class for the SecurityhomePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

//@IonicPage()
@Component({
  selector: 'page-securityhome',
  templateUrl: 'securityhome.html',
})
export class SecurityhomePage {
  private vistor_search : FormGroup;

  accessCode = "";
  authtoken = "";
  viscode = "";
  formmsg = "";
  security = false;
  reception = false;

  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,  
    private formBuilder: FormBuilder,
    private toastCtrl: ToastController, 
    public http: HttpClient,    
    public actionSheetCtrl: ActionSheetController, 
    public platform: Platform, 
    private storage: Storage,
    public loadingCtrl: LoadingController ,
    public global: GlobalProvider 
  ) {

    
    this.vistor_search = this.formBuilder.group({
      viscode: ['', Validators.required]
    });

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SecurityhomePage');
    this.storage.get('accesscode').then((val) => {
      console.log('acc = '+val);
      this.accessCode = val;
      this.storage.get('Authorization').then((val1) => {
        console.log('acc = '+this.accessCode);
        this.authtoken = val1;
        this.storage.get('userrole').then((val2) => {
          if(val2 == 'ROLE_RECEPTION'){
            this.security = false;
            this.reception = true;

          }else if(val2 == 'ROLE_SECURITY'){
            this.security = true;
            this.reception = false;

          }
        });
      });
      
    });
  }

  getVisitor(){
    
    const httpOptions = {
      headers: new HttpHeaders({
        //'Content-Type':  'application/json',
        //'Accept': 'application/json',
        'Authorization':this.authtoken,
      })
    };
    console.log('form in ');
    console.log(this.vistor_search.get('viscode').value);
    const url = this.global.baseUrl+"api/admin/visitor?verificationCode="+this.vistor_search.get('viscode').value;
    

    this.http.get(url, httpOptions)//requestOpt)
      .subscribe((data:any) => {
          if(data.error == true){
            //console.log(data.errorList[0].description);
            if(data.errorList[0].description == 'VISITOR_INFO_NOT_FOUND'){
              this.formmsg = 'Visitor Access Code Not Found!.';
            }else{
              let toast = this.toastCtrl.create({
                message: data.errorList[0].description,
                duration: 5000,
                position: 'bottom',
                showCloseButton:true,
                closeButtonText:'Close'
              });
              toast.present();
            }
            /*let toast = this.toastCtrl.create({
              message: data.errorList[0].description,
              duration: 5000,
              position: 'bottom',
              showCloseButton:true,
              closeButtonText:'Close'
            });
            if(data.errorList[0].description == 'VISITOR_INFO_NOT_FOUND'){

            }

            toast.onDidDismiss(() => {
              if(data.errorList[0].description == 'VISITOR_INFO_NOT_FOUND'){

              }
              console.log('Dismissed toast!');
            });
          
            toast.present();*/
          }else{
            //console.log(data.visitorDTO);
            this.navCtrl.push(ViewvisitorPage, {
              viscode:this.vistor_search.get('viscode').value 
            });
            //this.datas = data.visitorDTO;
            //console.log('------------*---------------');
            //console.log(this.datas);
            /*
            this.name = data.visitorDTO.name;
            this.surname = data.visitorDTO.surname;
            this.title = data.visitorDTO.title;
            this.idNumber = data.visitorDTO.idNumber;
            this.email = data.visitorDTO.email;
            this.mnumber = '+27'+data.visitorDTO.phones[0].number;
            this.company = data.visitorDTO.company;
            this.photoLocation = data.visitorDTO.photoLocation;*/
            //this.mnumber = '+27'+data.visitorDTO.phones[0].number;
            //this.registration = data.visitorDTO.cars[0].registration;
            //this.model = data.visitorDTO.cars[0].model;

            //console.log(this.registration+' mod '+this.model);

            //this.storage.set('usermail',data.visitorDTO.email);

            /*let toast = this.toastCtrl.create({
              message: 'Visitor created successfully!.',
              duration: 3000,
              position: 'bottom',
              showCloseButton:false,
              closeButtonText:'Close'
            });

            toast.onDidDismiss(() => {
              console.log('Dismissed toast');
            });
          
            toast.present();*/
          }
        }, error => {
        console.log(error);
        let toast = this.toastCtrl.create({
          message: 'Error!.',
          duration: 5000,
          position: 'bottom',
          showCloseButton:false,
          closeButtonText:'Close'
        });

        toast.onDidDismiss(() => {
          console.log('Dismissed toast');
        });
      
        toast.present();
        
    });
  }

  
  logout(){
    this.storage.clear();
    this.navCtrl.push(LoginPage);
  }

  redirectPage(params:string){
    console.log('params = '+params);
    if(params == 'VisitorsPreRegPage'){
      this.navCtrl.push(VisitorsPreRegPage);
    }else if(params == 'VisitorreportPage'){
      this.navCtrl.push(VisitorreportPage);
    }
      
  }
}



// WEBPACK FOOTER //
// ./src/pages/securityhome/securityhome.ts